
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Header from './components/Header/index.vue'
import LearnMap from './components/LearnMap/index.vue'
import WelcomeAsk from './components/WelcomeAsk/index.vue'
import StudySystem from './components/StudySystem/index.vue'
import More from './components/More/index.vue'
import { Observer } from 'mobx-vue'
import { getStaticJson } from '@xt/client/utils/get-static-json'
import { mapCourseButton, getCourseListHasbuy } from '@xt/client/utils/activities/index'
import type { ActivityBtn, CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    Header,
    LearnMap,
    WelcomeAsk,
    StudySystem,
    More
  },
  async asyncData(ctx) {
    const res = await getStaticJson<CalligraphyLevel2JsonResp>('/mocks/activity-calligraphy-level2.json')

    if (!res) return

    const isLogin = ctx.store.$storeUser.isLogin()
    const hasBuyIds = await getCourseListHasbuy()

    return {
      config: res,
      btnConfig: mapCourseButton({
        ...res,
        hasBuyIds,
        isLogin
      })
    }
  }
})
export default class CalligraphyLevel2 extends Vue {
  config: CalligraphyLevel2JsonResp | null = null
  btnConfig: ActivityBtn | null = null

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
